import { IconCloudDown, IconCloudUp, IconLoader, IconLoader2, IconPlus, IconSortDescending, IconTrashFilled, IconX } from '@tabler/icons-react'
import { useEffect, useState } from 'react'
import { ButtonIconSquare } from 'src/components/buttons'
import { StandardTable, StandardTableHeader, StandardTableRow, TablePlater } from 'src/components/standard.table'
import { Pagination, PaginationKeys } from 'src/types/pagination'
import { ModalAddProduct } from './component.addModal'
import { DropdownMenuDemo, DropdownMenuMain } from './component.dropdownMenu'
import { StandardTablePagination } from '../../../../../components/standard.pagination'
import { useProductAPI, useProductAPIs } from 'src/API/rest.products'
import { toast } from 'src/shadcn/ui/use-toast'
import { StandardAlertDialog } from 'src/components/standard.alert-dialog'
import { ImportExcelModal } from './component.importExcelModal'
import { isAllowedPermission } from 'src/lib/utils'
import { useGetAllowedMenus } from 'src/API/rest.role'
import { useDebounce } from 'use-debounce'
import { InputStandard } from 'src/components/standard.input'
import { FilterModal } from './component.filterModal'


export function ProductPage() {

    const searchParams = new URLSearchParams(window.location.search)
    const currentPageFromUrl = searchParams.get(PaginationKeys.CURRENT_PAGE)
    const dataPerPage = 15
    const [pagination, setPagination] = useState<Pagination>({
        currentPage: currentPageFromUrl ? parseInt(currentPageFromUrl) : 1,
        totalPages: Math.ceil(1 / dataPerPage) || 1,
        dataPerPage: dataPerPage
    })
    const [productsRow, setProductsRow] = useState<StandardTableRow[]>([])
    const [previousDataLength, setPreviousDataLength] = useState(0)
    const [openAddModal, setOpenAddModal] = useState(false)
    const [selectedProductId, setSelectedProductId] = useState<number | null | string>()
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [mode, setMode] = useState<'add' | 'edit'>('add')
    const [openImportModal, setOpenImportModal] = useState(false)
    const [search, setSearch] = useState('')
    const [debouncedInput] = useDebounce(search, 500);
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [productCategory, setproductCategory] = useState<number | null>(null);
    const [productSubCategory, setproductSubCategory] = useState<number | null>(null);

    const {
        products,
        error,
        isError,
        isFetched,
        isFetching,
        isLoading,
        totalProductCount,
        isDeleting,
        refetchProducts,
        deleteProductById,

    } = useProductAPI({
    })



    const headers: StandardTableHeader[] = [
        { label: 'Name', id: 'name', whiteSpace: 'nowrap' },
        { label: 'image', id: 'image', whiteSpace: 'nowrap' },
        { label: 'price', id: 'price', whiteSpace: 'nowrap' },
        { label: 'description', id: 'description', whiteSpace: 'nowrap' },
        { label: '', id: 'actions', width: '20px' },
    ]

    const {
        downloadProductDatas,
        isDownloadingProductDatas
    } = useProductAPIs()



    const deleteProduct = async () => {

        if (selectedProductId) {
            const response = await deleteProductById({
                productId: selectedProductId
            })
            if (response.success !== false) {
                toast({
                    title: 'Success',
                    description: 'Product deleted successfully',
                })
                refetchProducts()
                setOpenDeleteModal(false)
            } else {
                toast({
                    title: 'Error',
                    description: 'Error deleting product',
                })
            }
            setSelectedProductId(null)
        }

    }


    useEffect(
        () => {
            // setting prevouse data length for loading optimization
            if (isFetched && !isFetching) {
                console.log(products?.length)
                setPreviousDataLength(products?.length || 0)
            }

            //if successfully loaded
            if (isFetched && !isError) {
                setPagination({
                    currentPage: currentPageFromUrl ? parseInt(currentPageFromUrl) : 1,
                    totalPages: Math.ceil(totalProductCount / dataPerPage) || 1,
                    dataPerPage: dataPerPage
                })
                setProductsRow(products?.map(
                    (product) => {
                        return ({
                            id: String(product.id),
                            datas: {
                                name: { id: 'name', data: product.name },
                                image: { id: 'image', data: <img className=' h-10 w-10' src={`${process.env.REACT_APP_BACKEND_URL}/${product.image}`} /> },
                                price: { id: 'price', data: product.price },
                                description:{id:'description',data:<div className=' max-w-[300px] truncate'>{product.description}</div>},
                                actions: {
                                    id: 'actions', data: <DropdownMenuDemo
                                        rowId={String(product.id)}
                                        onDeleteAction={(rowid) => {
                                            setSelectedProductId(rowid);
                                            setOpenDeleteModal(true);
                                        }}
                                        onEditAction={(rowid) => {
                                            setSelectedProductId(rowid);
                                            setMode('edit');
                                            setOpenAddModal(true);
                                        }}
                                        isAllowedDelete={true}
                                        isAllowedEdit={true}
                                    />
                                }
                            }
                        })

                    }
                ) || [])
            }
            if (isError && isFetching === false) {
                toast({
                    description: String(error),
                })

            }
        }, [isFetching]
    )







    return (
        <div className=' grow  flex flex-col overflow-auto'>
            <StandardAlertDialog
                title="Are you absolutely sure?"
                description="This action cannot be undone. Are you sure you want to delete this product?"
                positiveLabel="Delete"
                negativeLabel="Cancel"
                positiveAction={deleteProduct}
                negativeAction={() => setOpenDeleteModal(false)}
                positiveIcon={isDeleting ? <IconLoader2 size={16} className=" animate-spin" /> : <IconTrashFilled size={16} />}
                negativeIcon={<IconX size={16} />}
                disableNegativeButton={isDeleting}
                disablePositiveButton={isDeleting}
                show={openDeleteModal}
            />
            <ModalAddProduct
                show={openAddModal}
                setShow={setOpenAddModal}
                refetchProducts={refetchProducts}
                mode={mode}
                productId={selectedProductId}
            />
            <ImportExcelModal
                show={openImportModal}
                setShow={setOpenImportModal}
            />
            <FilterModal
                // stateId={stateId}
                // setStateId={setStateId}
                ProductCategory={productCategory}
                productSubCategory={productSubCategory}
                show={openFilterModal}
                setShow={setOpenFilterModal}
                search={(filter) => {
                    setproductCategory(filter.productCategory)
                    setproductSubCategory(filter.productSubCategory)
                }}
            />
            <TablePlater className=' flex flex-col gap-2'>
                {/* Buttons section */}
                <div className=' flex justify-end w-full gap-4'>
                    {/* <InputStandard onChange={(e) => setSearch(e.target.value)} className=' lg:w-[400px] ' placeholder='Search' /> */}
                    {/* <ButtonIconSquare variant="white" icon={<IconCloudUp />} text="Import" onClick={() => { setOpenImportModal(true) }} /> */}
                    {true ? <ButtonIconSquare variant="secondary" icon={<IconPlus />} text="Add product" onClick={() => { setMode('add'); setOpenAddModal(true); }} /> : null}
                    {/* <DropdownMenuMain
                        onIconDownloadPressed={() => { downloadProductDatas() }}
                        onFilterButtonPressed={() => setOpenFilterModal(true)}
                    /> */}
                </div>
                <StandardTable
                    headers={headers}
                    rows={productsRow}
                    isLoading={isLoading}
                    rowsPerPrevousePage={previousDataLength}
                    isUpdating={isFetching}
                    isError={isError && isFetching === false}
                    onRetry={() => refetchProducts()}
                />
                <StandardTablePagination currentPage={pagination.currentPage} totalPages={pagination.totalPages} onChangePage={(page) => {
                    setPagination({ ...pagination, currentPage: page })
                }} />

            </TablePlater>
        </div>
    )

}



